import React from 'react'

import { ComponentManager } from 'components/ComponentManager'
import COMPONENT_CONFIGS from 'config/components'
import { useProject } from 'hooks'

import './ModuleManager.scss'

export default function () {
  const { project, updateProjectPart, canEdit, type } = useProject()

  const configs = COMPONENT_CONFIGS[type]

  const updateModules = (modules) => {
    updateProjectPart('modules', modules)
  }

  return (
    <div className='ModuleManager'>
      <ComponentManager
        type={type}
        components={project.modules}
        configs={configs}
        disabled={!canEdit}
        onUpdate={updateModules}
      />
    </div>
  )
}
